export const SLS_URL =
  import.meta.env.VITE_SLS_URL ||
  "Missing VITE_SLS_URL in environment variables";
